export default {
  CONTACT_LINK: 'Contact',
  SUPPORT_LINK: 'Support',
  PRIVACY_LINK: 'Privacy Policy',
  TERMS_LINK: 'Terms and Conditions',
  COPYRIGHT: '<strong>uFlex</strong>Reward',
  FOLLOW_US: 'Follow us on',
};
